module.exports = __webpack_public_path__ + "static/discovery-tour-explore-OberionIO-6695cc25db72d5e6a71554892906ad9e.png";